import styled from 'styled-components'

export const StatusDot = styled.div`
  background: ${({ statusColor }) => statusColor};
  height: 8px;
  width: 8px;
  border-radius: 50%;
`
